type TransformLike = {
  x: number;
  y: number;
};

type RectPositionLike = {
  left: number;
  top: number;
};

type PointLike = {
  x: number;
  y: number;
};

function getEffectiveGridSize(gridSize: number, zoom: number) {
  return gridSize * zoom;
}

function snapToStep(value: number, step: number) {
  if (step <= 0) {
    return value;
  }

  return Math.round(value / step) * step;
}

export function snapTransformToGridWithZoom<T extends TransformLike>(
  transform: T,
  gridSize: number,
  zoom: number
) {
  const effectiveGridSize = getEffectiveGridSize(gridSize, zoom);

  return {
    ...transform,
    x: snapToStep(transform.x, effectiveGridSize),
    y: snapToStep(transform.y, effectiveGridSize)
  };
}

type SnapTransformWithOriginParams<T extends TransformLike> = {
  transform: T;
  activeNodeRect: RectPositionLike;
  gridSize: number;
  zoom: number;
  gridOrigin: PointLike;
};

export function snapTransformToGridWithZoomAndOrigin<T extends TransformLike>({
  transform,
  activeNodeRect,
  gridSize,
  zoom,
  gridOrigin
}: SnapTransformWithOriginParams<T>) {
  const effectiveGridSize = getEffectiveGridSize(gridSize, zoom);

  if (effectiveGridSize <= 0) {
    return transform;
  }

  const absoluteLeft = activeNodeRect.left + transform.x;
  const absoluteTop = activeNodeRect.top + transform.y;

  const snappedAbsoluteLeft =
    snapToStep(absoluteLeft - gridOrigin.x, effectiveGridSize) + gridOrigin.x;
  const snappedAbsoluteTop =
    snapToStep(absoluteTop - gridOrigin.y, effectiveGridSize) + gridOrigin.y;

  return {
    ...transform,
    x: snappedAbsoluteLeft - activeNodeRect.left,
    y: snappedAbsoluteTop - activeNodeRect.top
  };
}
